import { TypedEventEmitter } from "./typedEventEmitter";

export const CommunicationEventName = {
  InboxOpened: "InboxOpened",
  InboxFetched: "InboxRefetched",
} as const;
export type CommunicationEventName =
  (typeof CommunicationEventName)[keyof typeof CommunicationEventName];

export type CommunicationEventsMap = {
  // list of supported events
  [CommunicationEventName.InboxOpened]: void;
  [CommunicationEventName.InboxFetched]: void;
};

/** Common tenant-to-tenant events. */
class CommunicationEventEmitter extends TypedEventEmitter<CommunicationEventsMap> {}

export const communicationEventEmitter = new CommunicationEventEmitter();
